import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type User } from "@travelix/core";
import { useAuth } from "@/lib/auth-provider";
import { getUserByEmail, unwrap, queryKeys } from "@/lib/api";

/**
 * Reads the current user's Firestore doc — the shape that powers the dashboard
 * (trips[] embedded, pendingInvites[] embedded, zero extra reads).
 */
export function useUserDoc(): UseQueryResult<User> & { email: string | null } {
  const { user } = useAuth();
  const email = user?.email?.toLowerCase() ?? null;

  const query = useQuery({
    queryKey: queryKeys.user(email),
    enabled: !!email,
    queryFn: async () => {
      return unwrap(getUserByEmail(email!));
    },
  });

  return Object.assign(query, { email });
}
